
import { AudioGraph } from "../AudioGraph";
import { AudioGraphNodeType } from "../AudioGraphNodeType";
import { AudioGraphNode } from "./AudioGraphNode";

export class MediaElementAudioSource extends AudioGraphNode<MediaElementAudioSourceNode>
{
  _audioElement:HTMLAudioElement;

  constructor( graph:AudioGraph, id:number, audioElement:HTMLAudioElement )
  {
    super( graph, id, AudioGraphNodeType.MediaElementAudioSource );
    this._audioElement = audioElement;
  }

  protected _assignAudioNode()
  {
    this._node = this._context.createMediaElementSource( this._audioElement );
  }
}